<template>
  <div v-if="activeContainer">
    Container
    <div class="border-container">
      <div>
        <span class="short-number-label">Left</span>
        <InputNumber v-model="left" showButtons class="short-number-inputs"/>

        <span class="mid-number-label">Width</span>
        <InputNumber v-model="width" showButtons class="short-number-inputs"/>
      </div>
      <div>
        <span class="short-number-label">Top</span>
        <InputNumber v-model="top" showButtons class="short-number-inputs"/>

        <span class="mid-number-label">Height</span>
        <InputNumber v-model="height" showButtons class="short-number-inputs"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useMainStore, useSlidesStore } from "@/store";

import {computed } from "vue";

import InputNumber from "primevue/inputnumber";
const slidesStore = useSlidesStore()

const { activeElementIdList } = storeToRefs(useMainStore())

const left = computed({
  get: () => {
    return Math.round(activeContainer.value?.left)
  },
  set: val => {
    if (activeContainer.value) {
      activeContainer.value.left = val
    }
  }
})

const top = computed({
  get: () => {
    return Math.round(activeContainer.value?.top)
  },
  set: val => {
    if (activeContainer.value) {
      activeContainer.value.top = val
    }
  }
})

const width = computed({
  get: () => {
    return Math.round(activeContainer.value?.width)
  },
  set: val => {
    if (activeContainer.value) {
      activeContainer.value.width = val
    }
  }
})

const height = computed({
  get: () => {
    return Math.round(activeContainer.value?.height)
  },
  set: val => {
    if (activeContainer.value) {
      activeContainer.value.height = val
    }
  }
})

const activeContainer = computed(() => {
  for (const section of slidesStore.getElementsByType('section')) {
    if (activeElementIdList.value.includes(section.id)) {
      return section
    }
  }
})
</script>

<style lang="scss" scoped>
.border-container {
  margin-top: 10px;
  width: 310px;
  border: solid 1px #ccc;
  padding: 10px;
  margin-bottom: 20px;
}

.short-number-inputs :deep(.p-inputtext) {
  width: 50px;
}

.short-number-label {
  margin-left: 10px;
  display: inline-block;
  width: 30px
}

.mid-number-label {
  margin-left: 20px;
  display: inline-block;
  width: 45px
}
</style>
